module.exports = __webpack_public_path__ + "static/media/dropdown.6e60888f.svg";